<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/dealerships">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Editar Concessionária</h2>
        <p class="page-subtitle">Altere os dados da concessionária selecionada</p>
      </div>
    </div>

    <div class="form-section">
      <app-dealership-form
        #dealershipForm
        [automakers]="data.automakers"
        [states]="data.states"
        [productLines]="data.productLines"
      />
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/dealerships">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>